module.exports = __webpack_public_path__ + "assets/images/02_fd0fc79d1b8b18b25df7cc9da490a65f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/02.png
// module id = 114
// module chunks = 0